import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import Figure from '../../Figure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'r',
  title: 'Circulating Supply'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get rightAlign() {
    return true;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td className="text-right">
        <Figure amount={this.props.row.circulatingSupply} zeroIsBlank />
      </td>
    );
  }
}


class CirculatingSupply extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get visible() {
    return false;
  }

  sortAscending(a, b) {
    if (! a.circulatingSupply) {
      return 1;
    }
    if (! b.circulatingSupply) {
      return -1;
    }
    if (a.circulatingSupply < b.circulatingSupply) {
      return -1;
    }
    if (a.circulatingSupply > b.circulatingSupply) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (! a.circulatingSupply) {
      return -1;
    }
    if (! b.circulatingSupply) {
      return 1;
    }
    if (a.circulatingSupply < b.circulatingSupply) {
      return 1;
    }
    if (a.circulatingSupply > b.circulatingSupply) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default CirculatingSupply;

